import { styled } from 'styled-components';

import { cssBreakpoints } from '#/theme/theme';

export const RadioButtons_Box_1 = styled.div`
  display: flex;
  padding-right: 0;

  &[data-has-columns] {
    padding: 6px;
    padding-right: 0;
  }

  &[data-has-right-padding] {
    padding-right: 50px;
  }

  &[data-has-column-count] {
    width: 100%;

    @media all and (min-width: ${cssBreakpoints.smUp}) {
      width: var(--w-sm, 100%);
    }
  }
`;
